import React from 'react';
import classnames from 'classnames';
import styles from './styles.css.js';

function CircleLoader(_a) {
  var className = _a.className,
      _b = _a.color,
      color = _b === void 0 ? '#f55700' : _b,
      _c = _a.size,
      size = _c === void 0 ? '20px' : _c,
      _d = _a.thickness,
      thickness = _d === void 0 ? '0.1em' : _d;
  var spinnerClasses = classnames(styles.loader, className);
  var boxShadow = "inset 0 0 0 " + thickness + " " + color;
  return React.createElement("span", {
    className: spinnerClasses,
    style: {
      fontSize: size
    }
  }, React.createElement("i", {
    className: styles.inner
  }, React.createElement("span", {
    className: styles.circle,
    style: {
      boxShadow: boxShadow
    }
  })));
}

export default CircleLoader;
//# sourceMappingURL=index.js.map
